import { i18n_t as $t } from '@/utils/i18n';
import { hasSubscriptionFlag } from '@/data/flags/local-flags';

export const getAllAccountsOption = () =>
    Object.freeze({
        text: $t('All Accounts'),
        id: '',
        className: 'account-chooser-all-accounts',
    });

// This is deprecated. For internationalization purposes, use getAllAccountsOption instead.
export const ALL_ACCOUNTS = getAllAccountsOption();

export const isParentAccount = (account) => {
    const usesSubaccounts = hasSubscriptionFlag('usesSubaccounts');

    return account.id ? usesSubaccounts && !/::/.test(account.id) : false;
};
